/** Defer work with scheduler.postTask(background) or setTimeout(0). */
export function scheduleBackgroundExport<T>(
	fn: () => T | Promise<T>,
): Promise<T> {
	return new Promise((resolve, reject) => {
		const run = () => {
			try {
				void Promise.resolve(fn()).then(resolve, reject);
			} catch (e) {
				reject(e);
			}
		};
		const sched = (
			globalThis as typeof globalThis & {
				scheduler?: { postTask: (cb: () => void, opts?: { priority: string }) => void };
			}
		).scheduler;
		if (sched?.postTask) {
			sched.postTask(run, { priority: 'background' });
		} else {
			setTimeout(run, 0);
		}
	});
}
